export default __webpack_public_path__ + "static/media/ic-crops-silverbeet.98b9063f.svg";